// Returns "ta" for text written in Tamil script, so screen readers and search
// engines know the language of API content such as event titles.
export const langOf = (text = "") => (/[஀-௿]/.test(text) ? "ta" : undefined);
